import './loader-overlay.css';

type LoaderOverlayProps = {
  /** When true, covers the nearest positioned ancestor instead of the viewport. */
  scoped?: boolean;
};

function LoaderOverlay({ scoped = false }: LoaderOverlayProps) {
  const positionClass = scoped ? 'absolute' : 'fixed';
  const zIndexClass = scoped ? 'z-10' : 'z-[9999]';

  return (
    <div
      className={`loading ${positionClass} inset-0 ${zIndexClass} flex items-center justify-center bg-black/45 backdrop-blur-[1px]`}
    >
      <div />
      <div />
      <div />
    </div>
  );
}

LoaderOverlay.defaultProps = {
  scoped: false,
};

export default LoaderOverlay;
